import React, { Component, PropTypes } from 'react';
import { InfiniteLoader, List, WindowScroller, AutoSizer, CellMeasurer } from 'react-virtualized';
import { FeedItemShape } from 'entities';

import cache from './PersistedCellSizeCache';

class FeedInfiniteLoader extends Component {

  constructor() {
    super();

    this.handleResize = this.handleResize.bind(this);
    this.forceRerenderRows = this.forceRerenderRows.bind(this);
  }

  componentDidMount() {
    // Measure all rows to restore scroll position.
    if (this._list && this.props.list.length > 0) this._list.measureAllRows();
    // Reset the measurements when the list is reset.
    if (this.props.page === 1) this.forceRerenderRows();
  }

  componentDidUpdate() {
    // Reset the measurements when the list is reset to the first page.
    if (this.props.page === 1) this.forceRerenderRows();
  }

  handleResize({width}) {
    // Only recompute list measurements if width changes.
    if (!this.width) this.width = width;
    if (this.width !== width) {
      this.forceRerenderRows();
      this.width = width;
    }
  }

  forceRerenderRows() {
    if (this._list && this.props.list.length > 0) {
      // Manually clear the cache and recompute.
      cache.clearCaches();
      this._list.measureAllRows();
      this._list.recomputeRowHeights();
    }
  }

  render() {
    const {
      totalCount,
      isNextPageLoading,
      hasFetchedManually,
      list,
      loadNextPage,
      isRowLoaded,
      rowRenderer,
      ...otherProps
    } = this.props;


    // Only load 1 page of items at a time after the first manual fetch
    const loadMoreRows = (hasFetchedManually && !isNextPageLoading) ? loadNextPage : () => {};

    return (
      <InfiniteLoader
        minimumBatchSize={process.env.KOOTH_PAGE_SIZE}
        threshold={1}
        isRowLoaded={isRowLoaded}
        loadMoreRows={loadMoreRows}
        rowCount={totalCount}
      >
        {({ onRowsRendered, registerChild }) => (
          <AutoSizer disableHeight onResize={this.handleResize}>
            {({ width }) => (
              <CellMeasurer
                ref={ref => this._cellMeasurer = ref}
                width={width}
                rowCount={list.length}
                cellRenderer={({ rowIndex, ...rest }) => rowRenderer({ index: rowIndex, ...rest })}
                cellSizeCache={cache}
                columnCount={1}
              >
                {({ getRowHeight }) => (
                  <WindowScroller>
                    {({ height, scrollTop }) => (
                      <List
                        {...otherProps}
                        ref={ref => {
                          // Store the reference and pass it on to InfiniteLoader as well
                          this._list = ref;
                          registerChild(ref);
                        }}
                        width={width}
                        height={height}
                        autoHeight
                        scrollTop={scrollTop}
                        rowCount={list.length}
                        rowHeight={getRowHeight}
                        rowRenderer={rowRenderer}
                        onRowsRendered={onRowsRendered}
                      />
                    )}
                  </WindowScroller>
                )}
              </CellMeasurer>
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    );
  }
}

FeedInfiniteLoader.propTypes = {
  page: PropTypes.number,
  totalCount: PropTypes.number,
  isNextPageLoading: PropTypes.bool,
  hasFetchedManually: PropTypes.bool,
  list: PropTypes.arrayOf(FeedItemShape),
  loadNextPage: PropTypes.func,
  isRowLoaded: PropTypes.func,
  rowRenderer: PropTypes.func,
  cellRenderer: PropTypes.func
};

export default FeedInfiniteLoader;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Feed/FeedInfiniteLoader/index.js
 **/